import request from "../utils/request";

export const getNewsClassifications = '/news/classification';

export function getAllNewsClassifications() {
    return request.request({
        url: '/news/classification/dict',
    })
}

export function modifyNewsClassifications(data: any) {
    return request({
        url: '/news/classification',
        method: data.id ? 'put' : 'post',
        data: data
    })
}

export function deleteNewsClassifications(id: number) {
    return request({
        url: '/news/classification',
        method: 'delete',
        params: {classificationId: id}
    })
}

export const getNews = '/news/'

export function addNews(data: any) {
    return request.request({
        url: '/news/',
        method: 'post',
        data: data
    })
}

export function deleteNews(id: number) {
    return request.request({
        url: '/news/',
        method: 'delete',
        params: {newsId: id}
    })
}
